export function getMMAEventsColumns() {
    return [{
        Content: 'EventOrder',
        PropertyContent: 'EventOrder',
        Width: '10%',
    }, {
        Content: 'Round',
        PropertyContent: 'Round',
        Width: '5%',
    }, {
        Content: 'ActionAthleteId',
        PropertyContent: 'ActionAthleteId',
        Width: '5%',
    }, {
        Content: 'AnswerAthleteId',
        PropertyContent: 'AnswerAthleteId',
        Width: '5%',
    }, {
        Content: 'Action',
        PropertyContent: 'Action',
        Width: '10%',
    }, {
        Content: 'Zone',
        PropertyContent: 'Zone',
        Width: '5%',
    }, {
        Content: 'Answer',
        PropertyContent: 'Answer',
        Width: '10%',
    }, {
        Content: 'Time',
        PropertyContent: 'Time',
        Width: '10%',
    }, {
        Content: 'World Time',
        PropertyContent: 'ActionTS',
        Width: '10%',
    }, {
        Content: 'GroundStart',
        PropertyContent: 'GroundStart',
        Width: '10%',
    }, {
        Content: 'GroundEnd',
        PropertyContent: 'GroundEnd',
        Width: '10%',
    }, {
        Content: 'GrappleStart',
        PropertyContent: 'GrappleStart',
        Width: '10%',
    }, {
        Content: 'GrappleEnd',
        PropertyContent: 'GrappleEnd',
        Width: '10%',
    }]
}

export function getBoxEventsColumns() {
    return [{
        Content: 'EventOrder',
        PropertyContent: 'EventOrder',
        Width: '10%',
    }, {
        Content: 'Round',
        PropertyContent: 'Round',
        Width: '10%',
    }, {
        Content: 'ActionAthleteId',
        PropertyContent: 'ActionAthleteId',
        Width: '15%',
    }, {
        Content: 'AnswerAthleteId',
        PropertyContent: 'AnswerAthleteId',
        Width: '15%',
    }, {
        Content: 'Action',
        PropertyContent: 'Action',
        Width: '15%',
    }, {
        Content: 'Answer',
        PropertyContent: 'Answer',
        Width: '15%',
    }, {
        Content: 'Sequence',
        PropertyContent: 'Sequence',
        Width: '10%',
    }, {
        Content: 'TimeSegment',
        PropertyContent: 'TimeSegment',
        Width: '10%',
    }, {
        Content: 'Time',
        PropertyContent: 'Time',
        Width: '10%',
    }, {
        Content: 'World Time',
        PropertyContent: 'ActionTS',
        Width: '10%',
    }]
}